import React from 'react';
import { CimmplePayDocLayout } from './CimmplePayDocLayout';
import { gettingStartedMarkdown } from '../../../content/cimmplepay/getting-started.md';

const GettingStarted: React.FC = () => {
  return (
    <CimmplePayDocLayout
      seoTitle="Getting Started | CimmplePay Docs"
      seoDescription="Connect to CimmplePay: environments, API conventions, your first health check call, minimum mapping data, and a practical rollout sequence."
      markdown={gettingStartedMarkdown}
    />
  );
};

export default GettingStarted;
